import React from "react";
import Button from "@mui/material/Button";
import { CustomAlert, showToastAlert } from "./components/CustomAlert";
import { useSelector } from "react-redux";
// You should implement sendCronjobService in your services folder similar to sendMailService
import { sendCronjobService } from "../services/adminCronjob";

const cronjobActions = [
    { label: "Remove external external posts", key: "remove_expired_ext_posts" },
    { label: "Unlist internal expired posts", key: "unlist_expired_int_posts" },
    { label: "Approve all valid external posts", key: "approve_all_valid_ext_post" },
    { label: "Increase post start date", key: "increase_post_start_date" },
    { label: "Send rejection mail to applicants of expired posts", key: "send_rejection_mail_to_applicants" },
    { label: "Add new field to models", key: "add_new_field" },
    // Add more cronjob actions as needed
];

const AdminCronjobList = () => {
    const admin = useSelector((state) => state.admin);

    const handleRunCronjob = async (type) => {
        if (!window.confirm(`Are you sure you want to run the "${type}" cronjob?`)) {
            return;
        }
        const response = await sendCronjobService(admin.token, type);
        if(response.status === 200) {
            showToastAlert(`Cronjob "${type}" executed`, "success");
        } else {
            showToastAlert(`Failed to execute cronjob "${type}"`, "error");
        }
    };

    return (
        <div>
            <h1 className="page-title-1 my-3 asdsd">Cronjobs</h1>
            <table style={{ width: "100%", marginBottom: "2rem", borderCollapse: "collapse" }}>
                <tbody>
                    {cronjobActions.map((action) => (
                        <tr key={action.key}>
                            <td style={{ padding: "1rem", border: "1px solid #ddd" }}>
                                {action.label}
                            </td>
                            <td style={{ padding: "1rem", border: "1px solid #ddd" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleRunCronjob(action.key)}
                                >
                                    Run Cronjob
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CustomAlert />
        </div>
    );
};

export default AdminCronjobList;
